<div class="dynamic-header">
  <div class="flex items-center gap-4">
    <button
      type="button"
      class="lg:hidden block text-xl"
      (click)="toggleState()"
    >
      <i class="ri-menu-3-line"></i>
    </button>
    <h1>{{ pageTitle }}</h1>
  </div>
  <div class="header-icons">
    <img src="/images/user.png" alt="User Avatar" class="avatar" />
  </div>
</div>
